import { render, staticRenderFns } from "./Dialog_SellCargoShop.vue?vue&type=template&id=8b366e20&scoped=true&"
import script from "./Dialog_SellCargoShop.vue?vue&type=script&lang=js&"
export * from "./Dialog_SellCargoShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b366e20",
  null
  
)

export default component.exports